export default __webpack_public_path__ + "static/icon_copywriting-d91256f087f035f6e5f84aa5ce831b63.png";